import externalScript from './external-script'

const scriptURL = 'https://www.youtube.com/iframe_api'
const idRegex = /.*(?:youtu.be\/|v\/|u\/\w\/|embed\/|watch\?.*v=)([^#&?]*).*/

let initialized = false

/* eslint-disable prefer-promise-reject-errors */
/* global YT */

const lib = {
  params: {},
  player: null,
  resolve: null,
  reject: null,

  videoID: function () {
    const match = lib.params.url.match(idRegex)
    return match && match.length > 1 ? match[1] : ''
  },

  init: function (params) {
    lib.params = params

    return new Promise((resolve, reject) => {
      lib.resolve = resolve
      lib.reject = reject

      if (initialized && lib.player) {
        return this.attachPlayer()
      }

      window.onYouTubeIframeAPIReady = this.attachPlayer

      externalScript.load(scriptURL)
    })
  },

  attachPlayer: function () {
    initialized = true
    lib.player = new YT.Player(lib.params.id, {
      width: lib.params.width || 640,
      height: lib.params.height || 390,
      events: {
        onReady: lib.playVideo
      },
      host: 'https://www.youtube.com',
      origin: lib.params.webRoot
    })
  },

  playVideo: function () {
    const id = lib.videoID()
    if (!id) {
      return lib.reject()
    }

    lib.player.loadVideoById(id)
    lib.resolve()
  }
}

export default lib
